import type { LoadedGraphWithViewpointMode } from '@ardoq/data-model';
import { uniq } from 'lodash';

export const collectAvailableTagNames = (
  loadedGraph: LoadedGraphWithViewpointMode
): string[] => uniq(loadedGraph.scopeData.tags.map(({ name }) => name));
